import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { KitchenStockItemService } from 'app/shared/services/kitchen-stock-item.service';
import { AuthService } from 'app/shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { NbThemeService } from '@nebular/theme';
import { MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'ngx-kitchen-stock',
  templateUrl: './kitchen-stock.component.html',
  styleUrls: ['./kitchen-stock.component.scss']
})
export class KitchenStockComponent implements OnInit {

  
  isDark: boolean = false;

  kitchenStock: any = null;
  form: FormGroup;
  isValidFormData: boolean = true;
  showProcessingIndicator = false;
  isReadOnly: boolean = false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };


  validationMessages = {
    'name': { 'required': 'This field is required' },
    'unit': { 'required': 'This field is required' },
    'unitCost': { 'required': 'This field is required' },
  };

  formErrors = {
    'name': '',
    'unit': '',
    'unitCost': '',
  };

  UNIT =[
    {value: 'PCS'},
    {value: 'kg'},
    {value: 'gm'},
    {value: 'mg'}, 
    {value: 'L'},
    {value: 'ml'},
    {value: 'm'},
    {value: 'ft'},
    {value: 'in'},
    {value: 'cm'},
    {value: 'mm'}, 
    {value: 'Kit'}, 
    {value: 'Pckt'}, 
    {value: 'Pack'}, 
    
  
  ];

  constructor(
              @Inject(MAT_DIALOG_DATA) public data,
              public dialogRef: MatDialogRef<KitchenStockComponent>,
              private fb: FormBuilder,
              private kitchenStockItemService: KitchenStockItemService,
              private toastr: ToastrService,
              private dialogService: DialogService,
              private themeService: NbThemeService,
              private router: Router,
              private authService: AuthService,
            ) { 
              this.kitchenStock =data;
              }

  ngOnInit(): void {

    this.getControlPermissions();
    this.initForm()

    this.form.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.form);
    });

    this.themeService.onThemeChange()
    .subscribe(themeName => {
         this.isDark  = themeName.name === 'dark' ? true : false;
       });

  } // nd oninit

  getControlPermissions() {
    let data = [];
     data =  this.authService.controlPermissionArray.filter((el) => {
      return el.moduleCode === 'KS';
    });
    if (data.length > 0) {
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  initForm(){
    this.form = this.fb.group({
      id: [this.kitchenStock ? this.kitchenStock.Id: null],
      name : [this.kitchenStock ? this.kitchenStock.Name : '',Validators.required],
      unit : [this.kitchenStock ? this.kitchenStock.Unit : '',Validators.required],
      unitCost : [this.kitchenStock ? this.kitchenStock.UnitCost : '',Validators.required],
    });

    this.isReadOnly = this.data ? true : false;

  }


  resetForm() {
    this.form.reset();
  }

  newButtonClick(): void {
    this.isReadOnly = false;
    this.enableForm();
    this.form.reset();

   }

  onClose() {
    this.resetForm();
    this.dialogRef.close();
   }

  saveButtonClick(): void {

    this.logValidationErrors(this.form, true);
   const formData = this.mapFormValuesToModel();

    if (this.isFilledFromFields()) {

      if(!this.form.value.id){

        this.showProcessingIndicator = true;
        this.kitchenStockItemService.create(formData)
          .subscribe(
            (res) => {
               if(res.status ===409){
                this.toastr.error('This kitchen stock itenm already exists', 'Warning');
                this.showProcessingIndicator = false; 
               }else if(res.status ===200){
                  this.toastr.success('Record added successfully', 'Success');
                  this.showProcessingIndicator = false;
                  this.onClose(); 
               }
                   

            },
            (err) => {
              this.toastr.error('Failed to add record', 'Failure');
              this.showProcessingIndicator = false;
              if (err instanceof HttpErrorResponse) {
                if (err.status == 401) {
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            },
          );

        }else{
          this.showProcessingIndicator = true;
          this.kitchenStockItemService.update(formData)
            .subscribe(
              (res) => { 
                  this.toastr.success('Record updated successfully', 'Success');
                  this.showProcessingIndicator = false;
                  this.onClose();
                  
              },
              (err) => {
                this.toastr.error('Failed to update record', 'Failure');
                this.showProcessingIndicator = false;
                if (err instanceof HttpErrorResponse) {
                  if (err.status == 401) {
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
              },
            );


        }
      
      } else {
          this.toastr.warning('Required Fields cannot be empty or invalid.', 'Error Message');
          this.showProcessingIndicator = false;
    }


  }


  enableForm(): void {
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].enable();
     // console.log(key);
    });
  }



  logValidationErrors(group: FormGroup = this.form, isDirty: boolean = false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (isDirty) {
        this.enableForm();
        this.form.controls[key].markAsTouched();
      }
      if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.validationMessages[key];
        console.log(messages)
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });
  }


  isFilledFromFields(): boolean {
    for (let key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != '' && this.formErrors[key] != '')
        return false;
    }
    return true;
  }



  mapFormValuesToModel() {
    let formData ={
      ...this.form.value,
      createdBy:this.authService.getUserLoggedIn()
    }
    return formData;

  }






}// end class
